import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"],
  _excluded2 = ["children", "level"],
  _excluded3 = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { filterDOMProps as $3GX9J$filterDOMProps } from "@react-aria/utils";
import $3GX9J$react, { forwardRef as $3GX9J$forwardRef } from "react";
import { useSlotProps as $3GX9J$useSlotProps, useStyleProps as $3GX9J$useStyleProps, useDOMRef as $3GX9J$useDOMRef } from "@react-spectrum/utils";
function $cd449e8defa988f0$var$Text(props, ref) {
  props = $3GX9J$useSlotProps(props, 'text');
  var _props = props,
    children = _props.children,
    otherProps = _objectWithoutProperties(_props, _excluded);
  var _$3GX9J$useStyleProps = $3GX9J$useStyleProps(otherProps),
    styleProps = _$3GX9J$useStyleProps.styleProps;
  var domRef = $3GX9J$useDOMRef(ref);
  return /*#__PURE__*/$3GX9J$react.createElement("span", _objectSpread(_objectSpread(_objectSpread({}, $3GX9J$filterDOMProps(otherProps)), styleProps), {}, {
    ref: domRef
  }), children);
}
/**
 * Text represents text with no specific semantic meaning.
 */
var $cd449e8defa988f0$export$5f1af8db9871e1d6 = /*#__PURE__*/$3GX9J$forwardRef($cd449e8defa988f0$var$Text);
function $c382fceb69609a50$var$Heading(props, ref) {
  props = $3GX9J$useSlotProps(props, 'heading');
  var _props2 = props,
    children = _props2.children,
    _props2$level = _props2.level,
    level = _props2$level === void 0 ? 3 : _props2$level,
    otherProps = _objectWithoutProperties(_props2, _excluded2);
  var _$3GX9J$useStyleProps2 = $3GX9J$useStyleProps(otherProps),
    styleProps = _$3GX9J$useStyleProps2.styleProps;
  var domRef = $3GX9J$useDOMRef(ref);
  var HeadingTag = "h".concat(level);
  return /*#__PURE__*/$3GX9J$react.createElement(HeadingTag, _objectSpread(_objectSpread(_objectSpread({}, $3GX9J$filterDOMProps(otherProps)), styleProps), {}, {
    ref: domRef
  }), children);
}
/**
 * Heading is used to create various levels of typographic hierarchies.
 */
var $c382fceb69609a50$export$a8a3e93435678ff9 = /*#__PURE__*/$3GX9J$forwardRef($c382fceb69609a50$var$Heading);
function $a42b6b1607b36926$var$Keyboard(props, ref) {
  props = $3GX9J$useSlotProps(props, 'keyboard');
  var _props3 = props,
    children = _props3.children,
    otherProps = _objectWithoutProperties(_props3, _excluded3);
  var _$3GX9J$useStyleProps3 = $3GX9J$useStyleProps(otherProps),
    styleProps = _$3GX9J$useStyleProps3.styleProps;
  var domRef = $3GX9J$useDOMRef(ref);
  return /*#__PURE__*/$3GX9J$react.createElement("kbd", _objectSpread(_objectSpread(_objectSpread({}, $3GX9J$filterDOMProps(otherProps)), styleProps), {}, {
    dir: "ltr",
    ref: domRef
  }), children);
}
/**
 * Keyboard represents text that specifies a keyboard command.
 */
var $a42b6b1607b36926$export$16e4d70cc375e707 = /*#__PURE__*/$3GX9J$forwardRef($a42b6b1607b36926$var$Keyboard);
export { $cd449e8defa988f0$export$5f1af8db9871e1d6 as Text, $c382fceb69609a50$export$a8a3e93435678ff9 as Heading, $a42b6b1607b36926$export$16e4d70cc375e707 as Keyboard };